import RequestsTable from '../../components/RequestsTable';

export default function Requests() {
  return <RequestsTable />;
}
